import { ELocaleStotageMigrationKeys } from './migrateLocaleStorage';

// Cognito/Amplify session keys are removed whatever else they contain: a federated username can
// hold a '/', which would otherwise read as a preference below.
const SESSION_PREFIXES = ['CognitoIdentityServiceProvider.', 'amplify-'];

const MIGRATION_MARKERS = new Set<string>(Object.values(ELocaleStotageMigrationKeys));

// The session-expired flag the login page reads once; a 401 cleanup racing the redirect must not
// remove it, or the user lands on sign-in with no explanation.
const KEPT_FLAGS = new Set<string>(['showToast']);

// A user's own table preferences: column layouts (`<username><route>`) and filters
// (`<profileId><route>}_filters`). Every one of those keys is built from a route path, so it holds
// a '/'. A key written before the user loaded starts `undefined` or `null`; it belongs to no one
// and would be restored for the next person, so it is not kept. The one-time table migration
// markers are kept too, or the next sign-in reruns the migrations and wipes the layouts.
const isTablePreference = (key: string) => key.includes('/') && !key.startsWith('undefined') && !key.startsWith('null');

const isKept = (key: string) =>
  !SESSION_PREFIXES.some((prefix) => key.startsWith(prefix)) &&
  (isTablePreference(key) || MIGRATION_MARKERS.has(key) || KEPT_FLAGS.has(key));

/**
 * Clears the signed-in session from localStorage on sign-out and on auth failure: Cognito/Amplify
 * tokens, the stored user, impersonation state and anything else not listed as kept. It used to be
 * `localStorage.clear()`, which also wiped every saved table view (PP-9563). Keeping a short list
 * rather than a list of session keys means a session key added later is still cleared.
 */
export const clearSessionStorage = () => {
  try {
    Object.keys(localStorage)
      .filter((key) => !isKept(key))
      .forEach((key) => localStorage.removeItem(key));
  } catch (error) {
    console.error(error);
  }
};
